module.exports = __webpack_public_path__ + "img/icon-kaufaufrechnung.e0e81bcd.svg";